import React from 'react';
import advocateProfilePic from '../../../assets/images/advocates-details/VaishnaviSingh.jpg';

const AdvocateVaishnaviSinghDetails = () => {
  return (
    <section className='team-details'>
      <div className='container'>
        <div className='row justify-content-between'>
          <div className='col-lg-5'>
            <div className='team-details__content'>
              <h2 className='team-details__title'>Read my story</h2>
              <p className='team-details__text'>
                Ms. Vaishnavi completed her B.A. LLB from KVRR Law College, Osmania University, in the year 2025. 
                Vaishnavi enrolled as an Advocate in the year 2025 and her areas of interest include Corporate Law, 
                Civil Litigation, Criminal Justice, and Alternative Dispute Resolution. 
                Currently she is practicing at Hon’ble High Court for the State of Telangana, Civil and Criminal Courts in Hyderabad. 
                She is also pursuing her Master’s in Criminology and Criminal Justice at 
                Osmania University to further her expertise in the legal and societal implications of crime. 
                She holds an Advanced Diploma in Contract Drafting, Negotiation, and Dispute Resolution, as well as 
                a qualification in Typewriting (Higher Grade) from the State Board of Technical Education and Training.
              </p>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img
                  src={advocateProfilePic}
                  alt='K Vaishnavi Singh'
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '100%',
                    height: 'auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  Kenvar Vaishnavi Singh. B.A. LLB.
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvocateVaishnaviSinghDetails;

